import React from 'react';

import { absoluteFill, breakpoints, calcPerc, colors, css, fluidRange, respondTo, styled, transitionDefault } from '~/styles';
import { ResourceItemModeProps } from './ResourceItem';
import { ResourcesItemActions, StyledTitle, StyledType } from './ResourcesItemCommon';


const StyledItem = styled.li`
  position: relative;
  cursor: pointer;
  flex: 0 0 215px;
  /* min-width: 200px;
  max-width: 230px; */
  ${fluidRange('paddingRight', '15px', '30px', breakpoints.xs, breakpoints.lg)}
  ${fluidRange('marginBottom', '15px', '30px', breakpoints.xs, breakpoints.lg)}
  ${transitionDefault};

  flex-basis: ${calcPerc(1, 6)};
  ${respondTo(1400, css`
    flex-basis: ${calcPerc(1, 5)};
  `)}
  ${respondTo(1200, css`
    flex-basis: ${calcPerc(1, 4)};
  `)}
  ${respondTo(1000, css`
    flex-basis: ${calcPerc(1, 3)};
  `)}

  &:hover {
    
  }
`

const StyledMain = styled.div`
  height: 0;
  padding-bottom: 100%; // square
  background-color: ${colors.white};
  position: relative;
  overflow: hidden;
`

const StyledSubs = styled.div`
  text-align: left;
  ${fluidRange('paddingTop', '10px', '18px', breakpoints.xs, breakpoints.lg)}

  h4 {
    color: ${colors.white};
    ${fluidRange('fontSize', '14px', '24px', breakpoints.xs, breakpoints.lg)}
    margin-bottom: 0.5em;
  }
  div {
    color: #939598;
  }
`

const StyledThumbnail = styled.div`
  ${absoluteFill};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #aaa;

  ${transitionDefault};
  transition-duration: 0.5s;
  transform-origin: center center;
  transition-timing-function: ease-out;

  li:hover > * > & {
    transform: scale(1.05);
  }
`

const StyledItemActions = styled(ResourcesItemActions)`
  position: absolute;
  right: 0;
  left: auto;
  top: 0;
  bottom: 0;
  width: ${calcPerc(80, 215)};
  background-color: rgba(0, 0, 0, 0.8);
  padding: ${calcPerc(20, 215)} ${calcPerc(18, 215)};

  flex-flow: column;
  align-items: center;
  justify-content: flex-start;

  a {
    margin-left: 0 !important;
    margin-bottom: 20%;
  }

  svg {
    path {
      stroke: ${colors.white};
    }
  }
  .icon-download {
    path {
      fill: ${colors.white};
    }
  }
  .icon-fav {
    &:hover:not(.active) {
      path {
        stroke: rgba(255, 200, 200, 0.8) !important;
      }
    }
  }
`


const ResourceItemModeGrid: React.FC<ResourceItemModeProps> = ({ 
  resource, thumbnailBgStyle, openResourceModal 
}) => {

  function createTitle() {
    return {
      __html: resource.title
    }
  }

  return (

    <StyledItem
      onClick={() => openResourceModal(resource)}
    >
      <StyledMain>
        <StyledThumbnail style={thumbnailBgStyle} />
        <StyledItemActions resource={resource} />
      </StyledMain>
      <StyledSubs>
        <StyledTitle dangerouslySetInnerHTML={createTitle()} />
        <StyledType>{resource.type} { resource.supplemental_text ? '/ ' + resource.supplemental_text : null }</StyledType>
      </StyledSubs>
    </StyledItem>
  )
}
export default ResourceItemModeGrid;



// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourceItemModeGrid.tsx